import React, { useCallback, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Row, Col } from "react-bootstrap";
import { AnimatePresence,motion } from 'framer-motion';
import '../lib/bootstrap.min.css'
import '../lib/css/shonir_analog_clock.css'
import './Main.css';
import './SubPage.css';

const ClockWidget = forwardRef((props,refParent) => {
    const ref = useRef(null);
    const intervalIdsRef = useRef([]);

    const getClockDate = useCallback((time_zone) => {
        if (time_zone) {
            return new Date(new Date().toLocaleString("en-US", { timeZone: time_zone }));
        }

        return new Date();
    }, []);

    const shonir_analog_clock = useCallback((time_zone, label, elements) => {
        if (!elements.clockEl || !elements.hEl || !elements.mEl || !elements.sEl || !elements.dateEl || !elements.timeEl) {
            return;
        }

        var d = getClockDate(time_zone);
    
        const _month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        const _day = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        var h = d.getHours(),
            m = d.getMinutes(),
            s = d.getSeconds(),
            day = d.getDay(),
            date = d.getDate(),
            month = _month[d.getMonth()],
            year = d.getFullYear(),
                    
          hDeg = h * 30 + m * (360/720),
          mDeg = m * 6 + s * (360/3600),
          sDeg = s * 6;
          elements.clockEl.style.backgroundColor = "rgba(20, 15, 0, 0.7)";

      if(month < 9) {
        month = "0" + month;
      }
      if(h < 10) {
        h = "0" + h;
      }
      if(m < 10) {
        m = "0" + m;
      }
      

      elements.hEl.style.transform = "rotate("+hDeg+"deg)";
      elements.mEl.style.transform = "rotate("+mDeg+"deg)";
      elements.sEl.style.transform = "rotate("+sDeg+"deg)";
      elements.dateEl.innerHTML = label + "<br />" + date+" / "+month+" / "+year;
      elements.timeEl.innerHTML =  _day[day] + ', '+h+':'+m;
    }, [getClockDate]);

    const init_shonir_analog_clock = useCallback((id, time_zone, label) => {
        var clockEl = document.getElementById(id);

        if (!clockEl) {
            return;
        }

        var existingDialLines = clockEl.getElementsByClassName('diallines');
        if (existingDialLines.length < 60) {
            var fragment = document.createDocumentFragment();

            for (var i = existingDialLines.length; i < 60; i++) {
                var dialLine = document.createElement('div');
                dialLine.className = 'diallines';
                dialLine.style.transform = "rotate(" + 6 * i + "deg)";
                fragment.appendChild(dialLine);
            }

            clockEl.appendChild(fragment);
        }

        var elements = {
            clockEl: clockEl,
            hEl: clockEl.querySelector('.hour-hand'),
            mEl: clockEl.querySelector('.minute-hand'),
            sEl: clockEl.querySelector('.second-hand'),
            dateEl: clockEl.querySelector('.date'),
            timeEl: clockEl.querySelector('.time')
        };

        shonir_analog_clock(time_zone, label, elements);

        var intervalId = window.setInterval(function () {
            shonir_analog_clock(time_zone, label, elements);
        }, 1000);

        intervalIdsRef.current.push(intervalId);
    }, [shonir_analog_clock]);

    const clearClockIntervals = useCallback(() => {
        intervalIdsRef.current.forEach((intervalId) => window.clearInterval(intervalId));
        intervalIdsRef.current = [];
    }, []);

    useImperativeHandle(refParent, () => ({
        exitPage: () => {
            clearClockIntervals();
        }
    }), [clearClockIntervals]);

    useEffect(() => {
        if (!props.profile) {
            return undefined;
        }

        for(var i =0; i < props.profile.length; i++){  
            init_shonir_analog_clock(
                props.profile[i].id,
                props.profile[i].timezone,
                props.profile[i].title
            )
        }

        return () => {
            clearClockIntervals();
        };
    }, [clearClockIntervals, init_shonir_analog_clock, props.profile]);

    return (
    <AnimatePresence>
        <Row>
            <Col md={12}>
                <motion.div 
                    ref={ref}
                    className='content-subpage'
                    style={{height:(props.height)+'px',backgroundColor:'rgba(50, 15, 0, 0.6)'}}
                    initial={{ opacity: 0, marginTop:-50 }}
                    animate={{ opacity: 1, marginTop: 0,  }}
                    exit={{opacity:0, marginTop:300}}
                    transition={{ duration: 1.2, ease: [0.87, 0, 0.13, 1] }}
                >
                    <h2>World Clock</h2>
                    <table style={{width:'100%'}} className='wclock'>
                        <tbody>
                            <tr>
                                {props.profile.map((timezone,key)=>(
                                    <td key={key}>
                                        <div id={timezone.id} className="analog_clock d-flex justify-content-center">
                                            <div>
                                                <div className="date"></div>
                                                <div className="info time"></div>
                                            </div>
                                            <div className="dot"></div>
                                            <div>
                                                <div className="hour-hand"></div>
                                                <div className="minute-hand"></div>
                                                <div className="second-hand"></div>
                                            </div>
                                            <div>
                                                <span className="h_3">3</span>
                                                <span className="h_6">6</span>
                                                <span className="h_9">9</span>
                                                <span className="h_12">12</span>
                                            </div>
                                            <div className="diallines"></div>
                                        </div>
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                    
                </motion.div>
            </Col>
        </Row>
    </AnimatePresence>
  )});

export default ClockWidget;
